import { SchemaGrammar } from '../../SchemaGrammar';

export class PostgresqlSchemaGrammar extends SchemaGrammar {}
